import { action, thunk } from "easy-peasy";
import { getUserDetailById } from "../../services/users.service";
import { getSubscriptionById } from "../../services/subscriptions.service";
import { updateEnterpriseCredits } from "../../helper/api.helper";

const userDetailModel = {
  // ===== STATE =====
  userInfo: null,
  subscription: null,
  counts: { projects: 0, avatars: 0, videos: 0 },
  lastActive: null,
  userDetailLoading: false,
  userDetailError: null,

  // ===== ACTIONS =====
  setUserInfo: action((state, payload) => {
    state.userInfo = payload;
  }),
  setSubscription: action((state, payload) => {
    state.subscription = payload;
  }),
  setCounts: action((state, payload) => {
    state.counts = payload;
  }),
  setLastActive: action((state, payload) => {
    state.lastActive = payload;
  }),
  setUserDetailLoading: action((state, payload) => {
    state.userDetailLoading = payload;
  }),
  setUserDetailError: action((state, payload) => {
    state.userDetailError = payload;
  }),

  clearUserDetail: action((state) => {
    state.userInfo = null;
    state.subscription = null;
    state.counts = { projects: 0, avatars: 0, videos: 0 };
    state.lastActive = null;
    state.userDetailLoading = false;
    state.userDetailError = null;
  }),

  // ===== THUNK =====
  fetchUserDetail: thunk(async (actions, userId) => {
    actions.setUserDetailLoading(true);
    actions.setUserDetailError(null);
    try {
      const { userInfo, counts, lastActive, subscriptionId } =
        await getUserDetailById(userId);

      const subscription = await getSubscriptionById(subscriptionId);

      actions.setUserInfo(userInfo);
      actions.setCounts(counts);
      actions.setLastActive(lastActive);
      actions.setSubscription(subscription);
    } catch (err) {
      actions.setUserDetailError(err.message);
    } finally {
      actions.setUserDetailLoading(false);
    }
  }),

  updateUserEnterpriseCredits: thunk(async (actions, { userId, credits }) => {
    const response = await updateEnterpriseCredits({ userId, credits });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message ||
          errorData.error ||
          "Failed to update enterprise credits",
      );
    }
    // Refresh user and subscription state
    await actions.fetchUserDetail(userId);
    return await response.json().catch(() => ({ success: true }));
  }),
};

export default userDetailModel;
